import './default/index.vue.mjs';
import './default-group/index.vue.mjs';
import { register } from '../../utils/index.mjs';
export { UiRadioEmits, UiRadioPropsOption } from './default/index.mjs';
export { UiRadioGroupEmits, UiRadioGroupInjectionKey, UiRadioGroupPropsOption } from './default-group/index.mjs';
import _sfc_main from './default-group/index.vue2.mjs';
import _sfc_main$1 from './default/index.vue2.mjs';

const UiRadioGroup = register.use(_sfc_main, "component");
const UiRadio = register.use(_sfc_main$1, "component");

export { UiRadio, UiRadioGroup, UiRadio as default };
//# sourceMappingURL=index.mjs.map
